import { useAuth } from '../context/AuthContext';

// Global function to handle 401 responses
export const handleUnauthorized = () => {
  // Remove token from localStorage
  localStorage.removeItem('token');
  // Redirect to login page
  window.location.href = '/login';
};

// Wrapper function for fetch that handles 401 responses
export const authenticatedFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
  const response = await fetch(url, options);
  
  if (response.status === 401) {
    handleUnauthorized();
    throw new Error('Unauthorized');
  }
  
  return response;
};

// Hook to get authenticated fetch with logout capability
export const useAuthenticatedFetch = () => {
  const { logout } = useAuth();
  
  const fetchWithLogout = async (url: string, options: RequestInit = {}): Promise<Response> => {
    const response = await fetch(url, options);
    
    if (response.status === 401) {
      logout();
      window.location.href = '/login';
      throw new Error('Unauthorized');
    }
    
    return response;
  };
  
  return fetchWithLogout;
}; 